import "./modules/global";

window.addEventListener("load", () => {
	const emailWrapper = document.querySelector(".approach-type.email");
	const email_btn = emailWrapper && emailWrapper.querySelector("#email_btn");
	const email_content = emailWrapper && emailWrapper.querySelector(".email");
	const email = email_content && email_content.innerHTML;
	const hiddenEmailInput = document.querySelector("#advisor_mail_hidden");

	emailWrapper &&
		emailWrapper.addEventListener("click", () => {
			emailWrapper.classList.add("fade");
			email_btn && email_btn.remove();
			email_content && email_content.classList.remove("hide");
			emailWrapper.classList.add("clicked");
		});
	if (email && hiddenEmailInput) {
		hiddenEmailInput.value = email;
	}
});
